
import {finalize} from 'rxjs/operators';
import { assign } from 'lodash';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { CLUser } from './user';
import { CLUserService, CLUserFilter } from './user.service';
import { CLUserFilterDialogComponent } from './user-filter-dialog.component';
import { NotifierService, DialogService } from '../../ui';

const FILTER_KEY = 'client-users.filter';

@Component({
  templateUrl: './user-list.component.html',
})
export class CLUserListComponent implements OnInit {

  filter: CLUserFilter;

  perPage = 10
  usersCount: number = 0
  users: CLUser[]

  constructor(
    private userService: CLUserService,
    private router: Router,
    private notifier: NotifierService,
    private dialogService: DialogService
  ) { }

  ngOnInit() {
    this.filter = new CLUserFilter();

    // Load filter from localStorage
    if(window.localStorage) {
      try {
        let data = window.localStorage.getItem(FILTER_KEY);

        let filterData = JSON.parse(data);

        assign(this.filter, filterData);
      }
      catch(err) {
      }
    }
    
    this.fetch();
  }

  fetchMore() {
    this.fetch(this.users.length);
  }

  private fetch(offset = 0, limit = this.perPage, replace = false) {
    this.notifier.startProgress();

    this.filter.offset = offset;
    this.filter.limit = limit;

    this.userService
      .users(this.filter).pipe(
      finalize(() => this.notifier.endProgress()))
      .subscribe((result) => {
        // Replace
        if (replace) {
          this.users = result.users;
        }
        // Append
        else {
          this.users = [...this.users || [], ...result.users];
        }

        this.usersCount = result.usersCount;
      });
    
    // Save filter to localStorage
    if(window.localStorage) {
      window.localStorage.setItem(FILTER_KEY, JSON.stringify(this.filter));
    }
  }

  showCLUser(user: CLUser, event: Event) {
    let nodeName = (<Element>event.target).nodeName;

    if (nodeName === 'TD' || nodeName === 'TR') {
      this.router.navigate(['shares-ledger', 'client-users', user.id]);
    }
  }

  applyFilter() {
    this.dialogService.show({
      component: CLUserFilterDialogComponent,
      props: {

        filter: this.filter,

        onClose: () => {
          this.dialogService.hide();
        },

        onApply: (filter: CLUserFilter) => {
          this.fetch(0, this.perPage, true);
        }
      }
    });
  }

  clearSearch() {
    this.filter.search = '';

    this.fetch(0, this.perPage, true);
  }

  delete(user: CLUser) {
    this.dialogService
      .confirmDelete('Voulez-vous supprimer ce compte client?')
      .subscribe((result) => {
        if (!result) {
          return;
        }

        this.notifier.startProgress();

        this.userService
          .delete(user.id)
          .subscribe((id) => {
            this.notifier.success('Compte client supprimé avec succès');

            this.fetch(0, this.users.length, true);
          }, (err) => {
            this.notifier.endProgress();
          });
      });
    
    return false;
  }
}
